<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style5', { sticky: isSticky }]">
      <MainNavbar />
    </div>
    <ServiceDetails />
    <MainFooter />    
  </div>
</template>

<script lang="ts">
import MainNavbar from "../Layouts/MainNavbar.vue";
import ServiceDetails from "../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../Layouts/MainFooter.vue";


import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeFivePage",
  components: {
    MainNavbar,
    ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>